import './linked-photo.css'
